<template>
	<b-button
		custom
		:class="['button display-flex align-items-center justify-content-center border-none padding-0 cursor-pointer', bgColorClasses]"
		v-on="$listeners"
	>
		<b-icon :class="iconColorClass">
			<component :is="iconName" class="button-icon" :class="{ normal, big }"/>
		</b-icon>
	</b-button>
</template>

<script>
import BButton from './Button.vue';
import BIcon from './Icon.vue';

export default {
	name: 'b-circular-icon-button',
	components: {
		BButton,
		BIcon
	},
	props: {
		/**
		 * Seta a cor do botão, pode ser qualquer cor base disponível no DLS
		 */
		color: {
			type: String,
			default: 'blue'
		},
		/**
		 * Seta o ícone do botão, pode ser qualquer ícone cujo nome inicia com icon-, disponível no DLS.
		 * Para adicinoar o icon-add, basta passar add como prop
		 */
		icon: {
			type: String,
			required: true
		},
		/**
		 * Se true icone tem `width=2.7rem` e `height=2.3rem`. Valor padrão se nenhum tamanho é definido
		 */
		normal: Boolean,
		/**
		 * Se true icone tem `width=3.5rem` e `height=3.2rem`
		 */
		big: Boolean,
		/**
		 * Customiza as cores do background do botão, devem ser usadas as classes de cores de background disponíveis no DLS
		 */
		customBackgroundColors: {
			type: String
		},
		/**
		 * Customiza as cores do ícone do botão, devem ser usadas as classes de cores disponíveis no DLS
		 */
		customIconColors: {
			type: String
		}
	},
	computed: {
		bgColorClasses() {
			if(this.customBackgroundColors) return this.customBackgroundColors;
			return `bg-${this.color}-lighter-4 bg-active-${this.color}-lighter-3 bg-focus-${this.color}-lighter-3 bg-hover-${this.color}-lighter-3`
		},
		iconColorClass() {
			if(this.customIconColors) return this.customIconColors
			return `${this.color}-base`
		},
		iconName() {
			return `icon-${this.icon}`
		}
	},
};
</script>

<style scoped lang="scss">
@import '../css/_variables.scss';

.button {
	width: 4.8rem;
	height: 4.8rem;
	border-radius: 100%;
	padding-top: 0.2rem;
}
.button .button-icon {
	width: 2.7rem;
	height: 2.3rem;
	&.normal {
		width: 2.7rem;
		height: 2.3rem;
	}
	&.big {
		width: 3.6rem;
		height: 3.2rem;
	}
}
</style>

<docs>
    Botão circular com ícone

    ```js
    <b-circular-icon-button icon="add" color="pink"></b-circular-icon-button>
		<b-circular-icon-button big icon="favorite" customBackgroundColors="bg-red-lighter-3" customIconColors="red-base"></b-circular-icon-button>

    ```
</docs>
